import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, DatePicker } from 'antd';

// Actions
import { getExcelFile } from '../../data/monitoring/actions';

// Selectors
import { getPreselectedMeterIds } from '../../data/app/selector';
import { getValidCloudPlan } from '../../data/meters/selectors';

// Constants
import moment from 'moment';
import { MODAL_SIZES } from '../../constants/modal';

class PeriodSelectModal extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            fromP1: moment().subtract(5, 'days').startOf('day'),
            toP1: moment().subtract(4, 'days').endOf('day'),
            fromP2: moment().subtract(2, 'days').startOf('day'),
            toP2: moment().subtract(1, 'days').endOf('day'),
        };
    }

    handleSubmit = () => {
        const { form, getExcelFile, meterIds } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            getExcelFile(meterIds, values.fromP1.valueOf(), values.toP1.valueOf(), values.fromP2.valueOf(), values.toP2.valueOf());
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    render() {
        const {
            form,
            isShown,
            isLoading = false,
            msgs,
            onCancel
        } = this.props;

        const {
            fromP1,
            toP1,
            fromP2,
            toP2,
        } = this.state;

        const { getFieldValue, getFieldDecorator } = form;

        return (
            <Modal
                key="excel-modal-change-event"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={msgs.dashboard.downloadExcel}
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.close}
                okText={msgs.download}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col span={9} offset={3}>{msgs.dashboard.excelFromP1}</Col>
                            <Col span={10} offset={2}>
                                <Form.Item>
                                    {getFieldDecorator('fromP1', {
                                        initialValue: fromP1,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <DatePicker />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={9} offset={3}>{msgs.dashboard.excelToP1}</Col>
                            <Col span={10} offset={2}>
                                <Form.Item>
                                    {getFieldDecorator('toP1', {
                                        initialValue: toP1,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <DatePicker />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={9} offset={3}>{msgs.dashboard.excelFromP2}</Col>
                            <Col span={10} offset={2}>
                                <Form.Item>
                                    {getFieldDecorator('fromP2', {
                                        initialValue: fromP2,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <DatePicker />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={9} offset={3}>{msgs.dashboard.excelToP2}</Col>
                            <Col span={10} offset={2}>
                                <Form.Item>
                                    {getFieldDecorator('toP2', {
                                        initialValue: toP2,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <DatePicker />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        meterIds: getPreselectedMeterIds(state),
        cloudPlan: getValidCloudPlan(state)
    }),
    {
        getExcelFile
    }
)(Form.create()(PeriodSelectModal));
